import { InmateActivitySummary } from '@reliance/types/models/InmateActivity';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { IApiResponse } from '../common/reliance-api-service';

type DateGrouping = 'Monthly' | 'Daily';

export const useInmateAccountSummary = (
  inmateId: number | null | undefined,
  dateGrouping?: DateGrouping
) => {
  return useAsync<InmateActivitySummary[]>(
    (currentInmateId?: number | null | undefined) => {
      const id = currentInmateId !== undefined ? currentInmateId : inmateId;
      if (!id) {
        return null;
      }

      const params: any = {
        inmateId: id,
      };

      if (dateGrouping) {
        params.dateGrouping = dateGrouping;
      }

      return api
        .get<InmateActivitySummary[] | IApiResponse<InmateActivitySummary[]>>('/inmate-account/summary', { params })
        .then((r) => (Array.isArray(r.data) ? r.data : (r.data as IApiResponse<InmateActivitySummary[]>).data ?? []));
    },
    // Use empty array when inmateId is null to prevent auto-execution (for manual control)
    inmateId === null ? [] : [inmateId, dateGrouping]
  );
};
